<template>
    <span v-if="powerConnected == null">
        _
    </span>

    <!-- Alimenté -->
    <span v-else-if="powerConnected === true" class="ui-badge status-badge--ok">
        <font-awesome-icon :icon="['fas', 'plug']" class="me-1" />
        ON
    </span>

    <!-- Non alimenté -->
    <span v-else class="ui-badge status-badge--low">
        <font-awesome-icon :icon="['fas', 'plug']" class="me-1" />
        OFF
    </span>
</template>

<script>
export default {
    props: {
        powerConnected: {
            type: Boolean,
            required: false
        }
    }
}
</script>